module.exports = __webpack_public_path__ + "img/proj-4.17e2c16d.png";